<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/2.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Email verified successfully!</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="login">your email was verified. You can continue using the website...</a> </div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->